import { Result } from 'core/infrastructure';
import { ThemeManager } from 'pos/ui';
import { Command } from 'pos/common';
import { TicketDTO } from 'core/api';

export default async function startTakeOutOrderIfNeeded(ticket: TicketDTO) {

	if (ThemeManager.isPhone())
		return Result.ok();

	if (ticket.Location.StartTakeOutOrderOnOpenTicket && !ticket.IsInUse) {
		return await Command.execute('startTakeOutOrder');
	}

	return Result.ok();
}